module.exports = __webpack_public_path__ + "static/media/Mapa-Rio Grande do Norte.d00df693.svg";